import Component from './Component';
import Armature from '../Prototype/Armature';
import { defaultDBAnimationName } from '../System/Animation/DBHelpers';
import dragonBones from 'pixi-dragonbones';

type PixiArmatureDisplay = dragonBones.PixiArmatureDisplay;
type Slot = dragonBones.Slot;
type Bone = dragonBones.Bone;

export default class DragonbonesComponent extends Component<
    PixiArmatureDisplay,
    Armature
> {
    public animationName: string = defaultDBAnimationName;
    public armatureName: string = undefined;
    public dragonbonesName: string = undefined;
    public playOnStart: boolean = true;
    public progress: number = 0;
    public boneMasks: string[] = [];
    public playTimes: number = undefined;

    public get lastAnimationName(): string {
        return this.container.animation.lastAnimationName;
    }

    public get width(): number {
        return this.container.armature.armatureData.aabb.width;
    }

    public get height(): number {
        return this.container.armature.armatureData.aabb.height;
    }

    public get slots(): Slot[] {
        return this.container.armature.getSlots();
    }

    public onAttach(gameObject: Armature, container: PixiArmatureDisplay, params: unknown): void {
        this.slots.forEach(slot => {
            const blendMode = (slot as any)?._blendMode;
            if (slot?.display && blendMode) {
                slot.display.blendMode = blendMode
            }
        });

        const names = this.gameObject.container.armature.armatureData.animationNames;

        this.animationName = names.includes(defaultDBAnimationName)
            ? defaultDBAnimationName
            : names[0] ?? defaultDBAnimationName;
    }

    public getSlot(name: string): Slot {
        return this.container.armature.getSlot(name);
    }

    public getSlotDisplay(name: string): PIXI.Container {
        const slot = this.getSlot(name);
        return slot.display ?? slot.rawDisplay;
    }

    public getBone(name: string): Bone {
        return this.container.armature.getBone(name);
    }

    public getBoneDisplay(name: string): unknown {
        return this.getSlot(name).display;
    }
}
